import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LegalAcknowledgementService {
  private readonly http = inject(HttpClient);
  getAcknowledgementDetails(
    acknowledgementType: string,
    participantId: string,
    sessionId: string,
  ): Observable<LegalAcknowledgement> {
    const url = `/api/legal-acknowledgements/${acknowledgementType}/participant/${participantId}`;
    return this.http.get<LegalAcknowledgementDto>(url, {
      params: { sessionId },
    }).pipe(
      map((dto) => ({
        id: dto.id,
        type: dto.type,
        content: dto.htmlContent,
      })),
    );
  }

  start(participantId: string): Observable<void> {
    return this.http.post<void>('/api/v1/legal-acknowledgements/started', { participantId });
  }

  acceptAcknowledgements(
    participantId: string,
    sessionId: string,
    consents: ConsentAcceptance[],
  ): Observable<{ success: boolean; message: string }> {
    return this.http
      .post<void>(`/api/legal-acknowledgements/accepted`, {
        participantId,
        sessionId,
        consents,
      })
      .pipe(
        map(() => ({
          success: true,
          message: 'Acknowledgements submitted successfully',
        })),
      );
  }
}

interface LegalAcknowledgementDto {
  id: number;
  type: string;
  htmlContent: string;
}

export interface LegalAcknowledgement {
  id: number;
  type: string;
  content: string;
}

export interface ConsentAcceptance {
  acknowledgementType: string;
  consentTextId: number;
}
